import request from '@/utils/request'

// export function getAgencyList(query) {
//   return request({
//     url: '/Chat/getAgencyList',
//     method: 'get',
//     params: query
//   })
// }

// export function saveAgency(data) {
//   return request({
//     url: '/Agency/saveAgency',
//     method: 'post',
//     data
//   })
// }

export function getAnUser(query) {
  return request({
    url: '/Chat/getAnUser',
    method: 'get',
    params: query,
  })
}

export function getUserList(query) {
  return request({
    url: '/Chat/getUserList',
    method: 'get',
    params: query,
  })
}

export function markMessageAsRead(data) {
  return request({
    url: '/Chat/markMessageAsRead',
    method: 'post',
    data,
  })
}

export function getDirectMessages(query) {
  return request({
    url: '/Chat/getDirectMessages',
    method: 'get',
    params: query,
  })
}

export function getNotReadCount(query) {
  return request({
    url: '/Chat/getNotReadCount',
    method: 'get',
    params: query,
  })
}

export function getAnGroup(query) {
  return request({
    url: '/Chat/getAnGroup',
    method: 'get',
    params: query,
  })
}

export function getGroupMessageList(query) {
  return request({
    url: '/Chat/getGroupMessageList',
    method: 'get',
    params: query,
  })
}

export function setSwitchGroupChat(query) {
  return request({
    url: '/Chat/setSwitchGroupChat',
    method: 'get',
    params: query,
  })
}

export function setSwitchAgencyChat(query) {
  return request({
    url: '/Chat/setSwitchAgencyChat',
    method: 'get',
    params: query,
  })
}
